export let TIMEOUT_DELAY: number = 300000;
export let TIMEOUT_WARNING_DELAY: number = 3300000;


// WEBPACK FOOTER //
// ./source/ts/constants/authenticate.ts